/* unplugin-vue-components disabled */import script from "./PendingInvoic.vue?vue&type=script&setup=true&name=PendingInvoic&lang=js"
export * from "./PendingInvoic.vue?vue&type=script&setup=true&name=PendingInvoic&lang=js"

const __exports__ = script;

export default __exports__